import React, { type JSX, useEffect, useState } from 'react'
import { Button } from '@mobi/component-library/Base/Buttons'
import { spacing } from '@mobi/component-library/Foundations'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { Modal } from '@mobi/component-library/Overlays/Modal'
import { isReactNativeApp, sendToNative, subscribeToNative } from '@mobi/web-native-comms/web'

export const CameraPermissionModal = (): JSX.Element | null => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (!isReactNativeApp) {
      return undefined
    }

    const showSubscription = subscribeToNative('SHOW_CAMERA_PERMISSION_MODAL', () => {
      setIsOpen(true)
    })

    const hideSubscription = subscribeToNative('HIDE_CAMERA_PERMISSION_MODAL', () => {
      setIsOpen(false)
    })

    return () => {
      showSubscription.dispose()
      hideSubscription.dispose()
    }
  }, [])

  const handleOpenSettings = () => {
    if (isReactNativeApp) {
      sendToNative('OPEN_CAMERA_SETTINGS')
    }
    handleClose()
  }

  const handleClose = () => {
    setIsOpen(false)
    if (isReactNativeApp) {
      sendToNative('CAMERA_PERMISSION_MODAL_DISMISSED')
    }
  }

  return (
    <Modal
      headerIcon='warning'
      headerIconAlignment='center'
      headerTitle='Enable Camera'
      headerSubtitle='Camera permission required to scan ticket. Please enable camera access in your device settings.'
      headerTextAlignment='center'
      dismissStatus='disallowed'
      footerComponent={
        <Flex flexDirection='column' gap={spacing.smx1} flex='1'>
          <Button isFullWidth color='primary' onClick={handleOpenSettings}>
            Open Settings
          </Button>

          <Button isFullWidth color='secondary_grey' onClick={handleClose}>
            Maybe Later
          </Button>
        </Flex>
      }
      isOpen={isOpen}
    />
  )
}
